import React from 'react';
import { cn } from '@frontend/shadcn/lib/utils';
import { Card, CardContent, CardHeader, CardTitle } from '@frontend/shadcn/components/ui/card';

// Analytics Card Components (reusable styled components matching Figma design)
interface AnalyticsCardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

const AnalyticsCard = React.forwardRef<HTMLDivElement, AnalyticsCardProps>(({ className, children, ...props }, ref) => (
  <Card
    ref={ref}
    className={cn('flex flex-col bg-[#ffffff] border border-[#e5e8eb] rounded-2xl', className)}
    {...props}
  >
    {children}
  </Card>
));
AnalyticsCard.displayName = 'AnalyticsCard';

interface AnalyticsCardHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

const AnalyticsCardHeader = React.forwardRef<HTMLDivElement, AnalyticsCardHeaderProps>(
  ({ className, children, ...props }, ref) => (
    <CardHeader ref={ref} className={cn('px-4 py-4 border-b border-[#e5e8eb]', className)} {...props}>
      {children}
    </CardHeader>
  ),
);
AnalyticsCardHeader.displayName = 'AnalyticsCardHeader';

interface AnalyticsCardTitleProps extends React.HTMLAttributes<HTMLHeadingElement> {
  children: React.ReactNode;
}

const AnalyticsCardTitle = React.forwardRef<HTMLParagraphElement, AnalyticsCardTitleProps>(
  ({ className, children, ...props }, ref) => (
    <CardTitle
      ref={ref}
      className={cn(
        "flex items-center gap-2 font-['Inter'] font-medium text-[16px] leading-[28px] text-[#16282d] mb-0",
        className,
      )}
      {...props}
    >
      {children}
    </CardTitle>
  ),
);
AnalyticsCardTitle.displayName = 'AnalyticsCardTitle';

interface AnalyticsCardContentProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

const AnalyticsCardContent = React.forwardRef<HTMLDivElement, AnalyticsCardContentProps>(
  ({ className, children, ...props }, ref) => (
    <CardContent ref={ref} className={cn('flex flex-col justify-between h-full px-4 pt-4 pb-6', className)} {...props}>
      {children}
    </CardContent>
  ),
);
AnalyticsCardContent.displayName = 'AnalyticsCardContent';

export { AnalyticsCard, AnalyticsCardHeader, AnalyticsCardTitle, AnalyticsCardContent };
export type { AnalyticsCardProps, AnalyticsCardHeaderProps, AnalyticsCardTitleProps, AnalyticsCardContentProps };
